import { List, ListItem } from 'palette/List';
import { NoFavouritesInfo } from '@common/Filters/components/NoFavouritesInfo';
import { useBrandsGroupFilter } from '@common/Filters/hooks/useBrandsGroupFilter';
import { useTranslate } from '@common/Translations';
import { BrandsGroupsList } from '../components/BrandsGroupsList';
import './BrandFilterDropdown.scss';

export function BrandsGroupFilter({ brands, brandGroupsData, activeBrandIds }) {
    const translate = useTranslate();
    const { hasHighlightedFilters, hasFavourites } = useBrandsGroupFilter(brandGroupsData, brands);

    return (
        <>
            { !hasFavourites && <NoFavouritesInfo />}
            {
                hasHighlightedFilters && (
                    <List>
                        <ListItem
                            label={translate('listing.filter.brandgroup.headline')}
                            labelType="large-title"
                        />
                        <BrandsGroupsList
                            activeBrandIds={activeBrandIds}
                            brandGroupsData={brandGroupsData}
                            brands={brands}
                        />
                    </List>
                )
            }
        </>
    );
}
